import { IUserRolesEntity, UserRole } from './user-role';
import { WorkOrderStatus } from '../work-order/work-order-status';

export interface IUserEntity {
    user_id: number | null;
    email: string;
    first_name: string;
    last_name: string;
    data: Partial<IUserDataEntity>;
    roles: Partial<IUserRolesEntity>;
    deleted: boolean;
    phone_number: string | null;
    creation_date: Date;
    last_updated: Date;
}

export interface IUserDataEntity {
    address?: string;
    primary: string;
    secondary: string;
    ignoreUserInCalendarList?: boolean;
    ignoreUserInSellerList?: boolean;
    autoAcceptCalendarEvent?: boolean;
    defaultFilters?: {
        planningItemSearchFilter?: {
            sub_type_ids?: number[];
        };
        workOrderSearchFilter?: {
            status?: WorkOrderStatus[];
            work_order_type_ids: number[];
        };
    };
    skillsMovetex?: SkillsMovetexEntity[];
    // True once the technician was successfully created in Movetex. We only ever push a technician once
    // (on first skill setup); Movetex's POST overwrites all their planning config, so we never re-sync.
    movetexTechnicianSynced?: boolean;
}

export enum SkillsMovetexEntity {
    maintenance = 'maintenance',
    repair = 'repair',
    placement = 'placement',
    lead = 'lead',
    delivery = 'delivery',
}

export function getDefaultUser(email: string): IUserEntity {
    return {
        user_id: null,
        email: email,
        first_name: null,
        last_name: null,
        data: {},
        roles: { roles: [UserRole.guest] },
        creation_date: null,
        last_updated: null,
        deleted: false,
        phone_number: null,
    };
}
